export default __webpack_public_path__ + "5fceb21e36f63f6ce9d98cb73c13c812.svg";